import dayjs, { type Dayjs } from 'dayjs';

const NOW_RE = /^now-(\d+)([a-z])$/i;

export interface ParsedExpression {
  from: Dayjs;
  to: Dayjs;
}

function parseDateToken(token: string): Dayjs | null {
  const trimmed = token.trim();
  const lower = trimmed.toLowerCase();

  if (lower === 'now') return dayjs();

  const match = lower.match(NOW_RE);
  if (match) {
    const [, amount, unit] = match;
    return dayjs().subtract(parseInt(amount), unit as dayjs.ManipulateType);
  }

  const parsed = dayjs(trimmed);
  return parsed.isValid() ? parsed : null;
}

export function parseExpression(input: string): ParsedExpression | null {
  const match = input.match(/(.+?)\s+to\s+(.+)/i);
  if (!match) return null;

  const from = parseDateToken(match[1]);
  const to = parseDateToken(match[2]);

  if (from?.isValid() && to?.isValid()) {
    return { from, to };
  }

  return null;
}
